<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="row-col">

    <a 
      data-dismiss="modal" 
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize">{{ chargeExists(charge.id) ? 'Update' : 'Create' }} Charge</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">
          <div class="p-a">
          
            <div 
              :class="{'invalid':errors.has('name')}" 
              class="md-form-group">
              <input 
                v-validate="'required'" 
                :disabled="loading" 
                v-model="charge.name" 
                type="text" 
                name="name" 
                class="md-input">
              <label>Name</label>
              <span 
                v-show="errors.has('name')" 
                class="form-error-msg">{{ errors.first('name') }}</span>
            </div>

            <div 
              :class="{'invalid':errors.has('amount')}" 
              class="md-form-group">
              <input 
                v-validate="'required|decimal|min_value:0'" 
                :disabled="loading" 
                v-model="charge.amount" 
                placeholder="0" 
                type="number" 
                name="amount" 
                class="md-input">
              <label>Amount (%)</label>
              <span 
                v-show="errors.has('amount')" 
                class="form-error-msg">{{ errors.first('amount') }}</span>
            </div>

            <!-- outlet selection -->
            <div class="md-form-group">
              <select 
                :disabled="loading" 
                v-model="charge.mode" 
                class="md-input">
                <option 
                  v-for="mode in modes" 
                  :value="mode.id" 
                  :key="mode.id">
                  {{ mode.name }}
                </option>
              </select>     
              <label>Charge Application</label>
            </div>

            <div class="md-form-group">
              <select
                :disabled="loading"
                v-model="charge.inclusive"
                class="md-input">
                <option :value="true">Include charge in product price</option>
                <option :value="false">Add charge to product price</option>
              </select>
              <label>Charge Mode</label>
            </div>

            <!-- Outlets select -->
            <div class="form-group m-t-sm">
              <label class="typo__label multiselect-label">Outlets</label>
              <multiselect
                id="ajaxOutlets"
                v-model="charge.outlets"
                :options="outletList"
                :multiple="true"
                :close-on-select="false"
                :limit="20"
                :hide-selected="true"
                label="name"
                track-by="id"
                @search-change="refreshOutletList"/>
            </div>

            <div class="form-group">
              <label>Options</label>

              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input 
                      :disabled="loading" 
                      v-model="charge.auto_assign_outlet" 
                      type="checkbox" 
                      class="has-value">
                    <i class="indigo"/>
                    Auto assign to outlet
                  </label>
                </p>
                <p>
                  <small>Automatically assign charge when new outlet is created</small>
                </p>
              </div>

              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input
                      :disabled="loading"
                      v-model="charge.taxable"
                      type="checkbox"
                      class="has-value">
                    <i class="indigo"/>
                    Taxable charge
                  </label>
                </p>
                <p>
                  <small>Charge amount will be included in taxes</small>
                </p>
              </div>

              <div class="form-group">
                <p>
                  <label class="md-switch">
                    <input 
                      :disabled="loading" 
                      :true-value="1" 
                      :false-value="0" 
                      v-model="charge.status"
                      type="checkbox"
                      class="has-value">
                    <i class="indigo"/>
                    Active charge
                  </label>
                </p>
                <p>
                  <small>Charge will be applied in orders</small>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-a b-t">
      <div class="text-right">
        <button 
          :disabled="loading"
          class="btn btn-fw white"
          data-dismiss="modal">Cancel</button>
        <button 
          :disabled="loading || !canManageTaxes"
          class="btn btn-fw primary"
          @click="submit()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PermissionMixin from '../tax-permission';

export default {
    mixins: [PermissionMixin],

    props: {
        charge: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            modes: [
                {
                    id: 0,
                    name: 'After order amount',
                },
                {
                    id: 1,
                    name: 'Before sub total amount',
                },
                {
                    id: 2,
                    name: 'Before final amount',
                },
            ],
        };
    },

    computed: {
        ...mapGetters('outlet', ['outletList']),
    },

    created() {
        this.getOutletListIfNecessary();
    },

    methods: {
        ...mapActions('outlet', ['getOutletListIfNecessary']),

        refreshOutletList: _.debounce(function(query) {
            this.getOutletListIfNecessary({ query: query });
        }, 500),

        submit() {
            var that = this;
            this.loading = true;

            this.$validator.validateAll().then(result => {
                if (result) {
                    that.$http[this.getSubmitMethod()](
                        that.getChargeApi(this.charge.id),
                        this.getSubmitValue(),
                    ).then(
                        response => {
                            if (response.status == '200') {
                                let data = response.data.data;
                                if (!that.chargeExists(that.charge.id)) {
                                    that.$parent.init_charge();
                                } else {
                                    $('#charge-popup').modal('hide');
                                }

                                let msg =
                                    'Charge has been successfully ' +
                                    (!that.chargeExists(that.charge.id)
                                        ? 'created'
                                        : 'updated');
                                toastr.success(msg);
                                this.$parent.refresh();
                            }

                            this.clearErrorValidation();
                            that.loading = false;
                        },
                        error => {
                            toastr.error(error.statusText);
                            that.loading = false;
                        },
                    );
                } else {
                    that.loading = false;
                }
            });
        },

        chargeExists(id) {
            return id != 0 && id != undefined;
        },

        getSubmitMethod() {
            if (this.chargeExists(this.charge.id)) {
                return 'patch';
            } else {
                return 'post';
            }
        },

        getSubmitValue() {
            return {
                ...this.charge,
                outlets: this.charge.outlets.map(o => o.id),
            };
        },

        getChargeApi(id) {
            if (this.chargeExists(id)) {
                return Laroute.route('franchise.inventory.charge.update', {
                    id: id,
                });
            } else {
                return Laroute.route('franchise.inventory.charge.store');
            }
        },

        clearErrorValidation() {
            var that = this;
            setTimeout(() => {
                that.errors.clear();
            }, 50);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/charge/charge_form.vue